module.exports = __webpack_public_path__ + "img/title-@2x.29889e06.png";